import { NavigationMenuChevron } from "@templates/design-system";
import { cn } from "@newxsystems/shared";
import { MegaMenuDropdownPanel } from "../MegaMenuDropdownPanel/MegaMenuDropdownPanel";
import { MegaMenuGroupPanel } from "../MegaMenuGroupPanel/MegaMenuGroupPanel";
import { MegaMenuLink } from "../MegaMenuLink/MegaMenuLink";
import type { IMegaMenuItemProps } from "./MegaMenuItem.props";

const controlClasses =
  "inline-flex min-h-11 max-w-full min-w-0 items-center rounded-full border border-transparent px-4 py-2 text-sm/[1.35] font-medium [overflow-wrap:anywhere] transition-colors duration-200 hover:border-foreground hover:bg-surface-200 focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-ring";

export const MegaMenuItem = ({
  isOpen,
  item,
  itemKey,
  onToggle,
  panelId,
  setTriggerRef,
  triggerId,
}: IMegaMenuItemProps) => {
  if (item.blockType === "megaMenuDirectLink") {
    return (
      <li className="min-w-0">
        <MegaMenuLink className={controlClasses} link={item.link} />
      </li>
    );
  }

  return (
    <li className="min-w-0">
      <button
        aria-controls={panelId}
        aria-expanded={isOpen}
        aria-haspopup="true"
        className={cn(
          controlClasses,
          "group cursor-pointer gap-2",
          isOpen && "border-foreground bg-surface-200",
        )}
        data-state={isOpen ? "open" : "closed"}
        id={triggerId}
        onClick={() => onToggle(itemKey)}
        ref={(node) => setTriggerRef(itemKey, node)}
        type="button"
      >
        {item.label}
        <NavigationMenuChevron />
      </button>
      {item.blockType === "megaMenuDropdown" ? (
        <MegaMenuDropdownPanel
          hidden={!isOpen}
          labelledBy={triggerId}
          links={item.links}
          panelId={panelId}
        />
      ) : null}
      {item.blockType === "megaMenuGroup" ? (
        <MegaMenuGroupPanel
          groupItems={item.groupItems}
          hidden={!isOpen}
          labelledBy={triggerId}
          panelId={panelId}
        />
      ) : null}
    </li>
  );
};

MegaMenuItem.displayName = "MegaMenu::MegaMenuItem";
